import { render } from "./App.vue?vue&type=template&id=6d8f976b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6d8f976b&lang=css"

import exportComponent from "/home/guilh/Milhagem/Telemetria/dt2-telemetria-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__